import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import Loader from "../../../components/Loader";
import { useResetPasswordLinkValidation } from "../hooks/useResetPasswordLinkValidation";
import ResetPasswordForm from "./ResetPasswordForm";

const ResetPassword = () => {
  const { uuid, email, isLoading, isLinkValid } =
    useResetPasswordLinkValidation();

  if (isLoading) {
    return (
      <div className="loader-center">
        <Loader color={"black"} />
      </div>
    );
  }

  if (isLinkValid) {
    return uuid && <ResetPasswordForm uuid={uuid} email={email} />;
  }

  return <TimeExpire />;
};

export default ResetPassword;

export const TimeExpire = () => {
  const navigate = useNavigate();

  useEffect(() => {
    toast.error("Link has expired");
    navigate("/forgotpassword");
  }, [navigate]);

  // return <div>Your password reset link has expired.</div>;
};
